module.exports = __webpack_public_path__ + "media/images/temp/accordion-image-2-167f852a834979985bf220fa45c3bc84.png";